/* eslint-disable jsx-a11y/anchor-has-content */
import {
  Box,
  Breadcrumb,
  BreadcrumbItem,
  Container,
  Flex,
  Heading,
  HStack,
  Icon,
  Square,
  Stack,
  Text,
  VStack,
} from "@chakra-ui/react";
import { useEffect } from "react";
import { HiArrowLeft, HiArrowRight } from "react-icons/hi";
import { RiDownload2Line } from "react-icons/ri";
import { useDispatch, useSelector } from "react-redux";
import {
  Link,
  useNavigate,
  useParams,
  useSearchParams,
} from "react-router-dom";
import Slider from "react-slick";
import "slick-carousel/slick/slick-theme.css";
import "slick-carousel/slick/slick.css";
import Layout from "../../../components/student/Layout/layout";
import AddVoucher from "../../../containers/student/models/add-voucher";
import SolveHomework from "../../../containers/student/models/solve-homework";
import VideoCard from "../../../containers/student/video/video";
import { openSolveHomeworkModel } from "../../../modules/admin-modules/models/Actions";
import {
  getVideoByIdRequest,
  getVideosByChapterIdRequest,
} from "../../../modules/students-modules/videos/Actions";

import VideosPreview from "../../../containers/student/video/videoPreview";
const StudentVideo = (props) => {
  const videoDetails = useSelector((state) => state.chapterVideos.videoDetails);

  const baseUrl = "https://enoughphysics.com/enoughapi";

  const [getSearchParams] = useSearchParams();
  const { id } = useParams();
  const chapter_name = getSearchParams.get("chapter_name");
  const chapter_id = getSearchParams.get("chapter_id");
  const selectedindex = getSearchParams.get("index");
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { chapterVideos, isLoading } = useSelector(
    (state) => state.chapterVideos
  );
  function SampleNextArrow(props) {
    const { className, style, onClick } = props;
    return (
      <HiArrowRight
        className={className}
        style={{
          ...style,
          display: "block",
          color: "#010038",
          fontSize: "30px",
        }}
        onClick={onClick}
      />
    );
  }

  function SamplePrevArrow(props) {
    const { className, style, onClick } = props;
    return (
      <HiArrowLeft
        className={className}
        style={{
          ...style,
          display: "block",
          color: "#010038",
          fontSize: "30px",
        }}
        onClick={onClick}
      />
    );
  }
  useEffect(() => {
    if (chapter_id) {
      dispatch(getVideosByChapterIdRequest(chapter_id));
    }
  }, [chapter_id]);

  useEffect(() => {
    if (id) dispatch(getVideoByIdRequest(id));
  }, [id]);

  const settings = {
    dots: false,
    infinite: false,
    speed: 500,
    slidesToShow: 3,
    slidesToScroll: 3,
    initialSlide: 0,
    nextArrow: <SampleNextArrow />,
    prevArrow: <SamplePrevArrow />,
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 3,
        },
      },
      {
        breakpoint: 900,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 2,
          initialSlide: 2,
        },
      },
      {
        breakpoint: 600,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
        },
      },
    ],
  };

  return (
    <Layout color="main_1" bg="white" isLoading={isLoading}>
      <Container maxW="container.2xl" h="100%" my="100px" mb="165px" w="100%">
        <VStack spacing={8} h="100%" w="100%" alignItems="flex-start" mt={20}>
          <Breadcrumb>
            <BreadcrumbItem>
              <Link to={`/chapter/${videoDetails?.chapter?.id}/video`}>
                <Text>Video</Text>
              </Link>
            </BreadcrumbItem>

            <BreadcrumbItem isCurrentPage>
              <Text textTransform="capitalize">{chapter_name}</Text>
            </BreadcrumbItem>
          </Breadcrumb>

          <Heading as="h3" color="main_1" textAlign="center" w="100%">
            {chapter_name}
          </Heading>

          {chapterVideos?.length == 0 && (
            <Heading
              as="h6"
              color="main_1"
              textAlign="center"
              w="100%"
              fontSize="20px"
            >
              You Didn't pay for this chapter
              <a
                href="https://wa.me/+201025830160"
                style={{ textDecoration: "underline" }}
                target="_blank"
                rel="noreferrer"
              >
                , Connect with the assistant!
              </a>
            </Heading>
          )}
          <Slider {...settings} className="slider">
            {chapterVideos?.map((data, idx) => {
              return (
                <VStack>
                  <VideoCard
                    key={idx}
                    data={data}
                    index={idx}
                    selectedindex={selectedindex}
                    handelClick={() => {
                      navigate(
                        `/video/${data?.id}?chapter_name=${chapter_name}&chapter_id=${chapter_id}&index=${idx}`
                      );
                    }}
                  />
                </VStack>
              );
            })}
          </Slider>
          <Stack
            flexDirection="column"
            w="100%"
            justifyContent="space-between"
            alignItems="flex-start"
            gap={{ base: 10, md: 4 }}
          >
            {videoDetails?.url == "no" ? (
              <Heading>Comming Soon</Heading>
            ) : (
              (videoDetails?.suspended === 0 ||
                videoDetails?.user_video_suspended === 0) && (
                  <VStack
                    alignItems="center"
                    justifyContent="center"
                    w="100%"
                    h="100%"
                    spacing="40px"
                    m="0 !important"
                    mt="10px !important"
                  >
                    <VideosPreview />

                    {/* video materials  */}
                    <VStack
                      w={{ base: "100%", md: "80%" }}
                      alignItems="flex-start"
                      color="main_1"
                    >
                      {videoDetails?.files &&
                        videoDetails?.files?.length != 0 && (
                          <Text fontSize="26px" fontWeight="500">
                            Video materials
                          </Text>
                        )}
                      <Flex w="100%" flexWrap="wrap" gap="4">
                        {videoDetails?.files?.map((val, idx) => {
                          return (
                            <HStack
                              key={idx}
                              w="23.5%"
                              h="70px"
                              bg="main_1_light"
                              justify="space-between"
                              borderRadius="8px"
                              p="10px"
                              position="relative"
                            >
                              <Text>File title</Text>

                              <Square
                                size="40px"
                                bg="main_1"
                                color="white"
                                borderRadius="8px"
                              >
                                <Icon as={RiDownload2Line} />
                              </Square>
                              <a
                                href={`${baseUrl}/${val?.file}`}
                                download
                                style={{
                                  width: "100%",
                                  height: "100%",
                                  position: "absolute",
                                }}
                                target="_blank"
                                rel="noreferrer"
                              ></a>
                            </HStack>
                          );
                        })}
                      </Flex>
                    </VStack>

                    {/* video description */}

                    {videoDetails?.over_view && (
                      <VStack
                        w={{ base: "100%", md: "80%" }}
                        alignItems="flex-start"
                        color="main_1"
                      >
                        <Text fontSize="26px" fontWeight="500">
                          Video Description{" "}
                        </Text>
                        <Text fontSize="20px">{videoDetails?.over_view} </Text>
                      </VStack>
                    )}

                    {videoDetails?.homework?.name && (
                      <VStack
                        w={{ base: "100%", md: "80%" }}
                        alignItems="flex-start"
                        color="main_1"
                      >
                        <Text fontSize="26px" fontWeight="500">
                          Video Related Homework{" "}
                        </Text>
                        <Box
                          onClick={() => dispatch(openSolveHomeworkModel())}
                          style={{
                            paddingLeft: "20px",
                            cursor: "pointer",
                            textDecoration: "underline",
                            fontWeight: "500",
                          }}
                        >
                          {videoDetails?.homework?.name}
                        </Box>
                      </VStack>
                    )}

                    {videoDetails?.exams?.length > 0 && (
                      <VStack
                        w={{ base: "100%", md: "80%" }}
                        alignItems="flex-start"
                        color="main_1"
                      >
                        <Text fontSize="26px" fontWeight="500">
                          Video Related Exams{" "}
                        </Text>
                        {videoDetails?.exams?.map((val) => {
                          return (
                            <Box
                              style={{
                                paddingLeft: "20px",
                                cursor: "pointer",
                                textDecoration: "underline",
                                fontWeight: "500",
                              }}
                              onClick={() =>
                                navigate(
                                  `/exam-guide/${val?.id}?name=${videoDetails?.chapter?.name}`
                                )
                              }
                            >
                              {val?.name}
                            </Box>
                          );
                        })}
                      </VStack>
                    )}

                    {videoDetails?.quiz_hw?.length > 0 && (
                      <VStack
                        w={{ base: "100%", md: "80%" }}
                        alignItems="flex-start"
                        color="main_1"
                      >
                        <Text fontSize="26px" fontWeight="500">
                          Video Related Exams{" "}
                        </Text>
                        {videoDetails?.quiz_hw?.map((val) => {
                          return (
                            <Box
                              style={{
                                paddingLeft: "20px",
                                cursor: "pointer",
                                textDecoration: "underline",
                                fontWeight: "500",
                              }}
                              onClick={() =>
                                navigate(
                                  `/solve-exam/${val?.id}?name=${videoDetails?.chapter?.name}`
                                )
                              }
                            >
                              {val?.name}
                            </Box>
                          );
                        })}
                      </VStack>
                    )}
                  </VStack>
                )
            )}
          </Stack>
        </VStack>
      </Container>
      <AddVoucher video_id={videoDetails?.id} />

      <SolveHomework data={videoDetails?.homework} setSelectedData={() => {}} />
    </Layout>
  );
};

export default StudentVideo;
